module.exports = __webpack_public_path__ + "img/express.c0262680.svg";